import React from 'react'
import { Filter } from '@e3dc-react/shell/Elements/Filter'
import { ChargingSessionStatusFilter } from '../../shared/components/ChargingSessionStatusFilter'
import { ChargingSessionStatus, MIDMeterFilterValue } from '../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useTypedSelector } from 'src/State/RootReducer'
import { useDispatch } from 'react-redux'
import { updateChargingSessionsFilters } from 'src/State/E-Mobility/EMobilityStateAction'

interface ChargingSessionsFiltersProps {
  sessionStatusFilterOptions: ChargingSessionStatus[]
  wallboxFilterOptions: {
    label: string
    value: string
  }[]
  ocpiTokenIdsFilterOptions: {
    label: string
    value: string
  }[]
  shouldDisplayMidMeter: boolean
}

/**
 * Charging sessions filters for larger device screens.
 * It displays all charging sessions filter buttons.
 */
export const ChargingSessionsFilters: React.FC<ChargingSessionsFiltersProps> = ({
  sessionStatusFilterOptions,
  wallboxFilterOptions,
  ocpiTokenIdsFilterOptions,
  shouldDisplayMidMeter,
}) => {
  const { t } = useCustomTranslation()

  const chargingSessionFilters = useTypedSelector(state => state.eMobility.chargingSessionsFilters.filters)
  const dispatch = useDispatch()

  const wallboxIds = chargingSessionFilters?.wallboxIds ?? []
  const sessionStatuses = chargingSessionFilters?.statuses ?? []
  const ocpiTokenIds = chargingSessionFilters?.ocpiTokenIds ?? []
  const midMeter = chargingSessionFilters?.midMeter ?? []

  const midMeterOptions = [
    { value: MIDMeterFilterValue.withMIDMeter, label: t(`emobility.chargingSession.${MIDMeterFilterValue.withMIDMeter}`) },
    { value: MIDMeterFilterValue.withoutMIDMeter, label: t(`emobility.chargingSession.${MIDMeterFilterValue.withoutMIDMeter}`) },
  ]

  return (
    <>
      <Filter
        label={t('emobility.chargingSession.wallbox')}
        options={wallboxFilterOptions}
        value={wallboxIds}
        onChange={value => {
          dispatch(updateChargingSessionsFilters({ ...chargingSessionFilters, wallboxIds: value, page: 0 }))
        }}
      />
      <ChargingSessionStatusFilter
        value={sessionStatuses}
        onChange={value => {
          dispatch(updateChargingSessionsFilters({ ...chargingSessionFilters, statuses: value, page: 0 }))
        }}
        options={sessionStatusFilterOptions}
      />
      <Filter
        label={t('emobility.chargingSession.authentication')}
        value={ocpiTokenIds}
        options={ocpiTokenIdsFilterOptions}
        onChange={value => {
          dispatch(updateChargingSessionsFilters({ ...chargingSessionFilters, ocpiTokenIds: value, page: 0 }))
        }}
      />
      {shouldDisplayMidMeter && (
        <Filter
          label={t('emobility.chargingSession.mid-status')}
          options={midMeterOptions}
          value={midMeter}
          onChange={value => {
            dispatch(updateChargingSessionsFilters({ ...chargingSessionFilters, midMeter: value, page: 0 }))
          }}
        />
      )}
    </>
  )
}
